import { IShippingEstimate } from '../../faire/carts/IShippingEstimate';
import { IInformationMessage } from '../../indigofair/data/IInformationMessage';

export namespace IShipmentGroup {
  /**
   * Return an instance of IShipmentGroup with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (partial?: Partial<IShipmentGroup>): IShipmentGroup =>
    ({
      cart_item_tokens: [],
      ...(partial ?? {}),
    }) as IShipmentGroup;
}

export interface IShipmentGroup {
  /**
   * The title of the shipment group, something like "Ships by Aug 20, 2021".
   */
  title: string | undefined;
  /**
   * The list of cart items that ship within this window.
   * @protobufOption (.faire.common.tokenType) = CART_ITEM
   * @protobufOption (faire.common.diffAs) = UNORDERED
   */
  cart_item_tokens: Array<string>;
  shipping_estimate: IShippingEstimate | undefined;
  /**
   * Use to show a promo message that belongs only to a particular shipping group within a brand cart.
   * Used for FFW but no longer in use.
   * @deprecated
   */
  brand_promo_string: string | undefined;
  /**
   * Information message for when the shipment group is below the guaranteed free shipping threshold
   */
  free_shipping_threshold_information_message: IInformationMessage | undefined;
  /**
   * This is true if shipment group meets free shipping threshold. The frontend
   * should use this to decide which icon and string to display
   */
  is_above_free_shipping_threshold: boolean | undefined;
  /**
   * Use to store shipping window for shipment group
   */
  expected_ship_date: number | undefined;
  expected_ship_window_days: number | undefined;
}
